export const FORME_CERCHIO = [
  {
    value: 'punto',
    label: 'Punto',
    icon: 'punto',
    caption: 'Placeholder descrizione punto.',
  },
  {
    value: 'raggio',
    label: 'Raggio',
    icon: 'raggio',
    caption: 'Placeholder descrizione raggio.',
  },
  {
    value: 'diametro',
    label: 'Diametro',
    icon: 'diametro',
    caption: 'Placeholder descrizione diametro.',
  },
  {
    value: 'corda',
    label: 'Corda',
    icon: 'corda',
    caption: 'Placeholder descrizione corda.',
  },
  {
    value: 'arco',
    label: 'Arco',
    icon: 'arco',
    caption: 'Placeholder descrizione arco.',
  },
  {
    value: 'settore',
    label: 'Settore',
    icon: 'settore',
    caption: 'Placeholder descrizione settore.',
  },
  {
    value: 'semicerchio',
    label: 'Semicerchio',
    icon: 'semicerchio',
    caption: 'Placeholder descrizione semicerchio.',
  },
  {
    value: 'circonferenza',
    label: 'Circonferenza',
    icon: 'circonferenza',
    caption: 'Placeholder descrizione circonferenza.',
  },
  {
    value: 'cerchio',
    label: 'Cerchio',
    icon: 'cerchio',
    caption: 'Placeholder descrizione cerchio.',
  },
];

export const getFormaCerchioOption = (value) =>
  FORME_CERCHIO.find((f) => f.value === value);

export const getFormaCerchioLabel = (value) =>
  getFormaCerchioOption(value)?.label ?? '';
